import { spawn, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';

export function makeRestartable(saga) {
  return function*() {
    yield spawn(function*() {
      while (true) {
        try {
          yield call(saga);
          console.error(
            'Unexpected root saga termination. The root sagas are supposed to be sagas that live during the whole app lifetime!',
            saga
          );
        } catch (e) {
          console.error('Saga error, the saga will be restarted', e);
        }
        yield delay(1000); // Avoid infinite failures blocking
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/utils/redux/saga.js